import type { Item } from '@easymoving/types';

export type NeedsReason = 'destination' | 'room' | 'category';

/** Why an item still needs attention (PRD §10.5). Empty = fully decided. */
export function needsDecisionReasons(item: Item): NeedsReason[] {
  const reasons: NeedsReason[] = [];
  if (item.destination === 'undecided' || item.progressStatus === 'needs_decision')
    reasons.push('destination');
  if (!item.room) reasons.push('room');
  if (!item.category) reasons.push('category');
  return reasons;
}

export function needsDecision(item: Item): boolean {
  return needsDecisionReasons(item).length > 0;
}

export function filterNeedsDecision(items: Item[]): Item[] {
  return items.filter(needsDecision);
}
